import React from 'react';
import { TableCell } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useProductSettingsContext } from '../context/ProductSettingsContext';
import { isSunday, maxInMarketDate } from '../utils/inMarketDate';

export const SalesGeographyInMarketDatePicker = ({ row, className }) => {
    const { getItemPropertyOverrideDate, getFloorDate, getCeilingDate, saveItemPropertyOverride, showInMarketDateError } = useProductSettingsContext();
    const value = getItemPropertyOverrideDate(row.salesGeographyLevelId, row.salesGeographyId);
    const min = getFloorDate(row);
    const ceiling = getCeilingDate(row);
    const weekLimit = maxInMarketDate();
    // Tightest upper bound: the ceiling (descendant dates and the item's end in-market date) and the
    // 52-week limit (date strings sort chronologically).
    const max = [ceiling, weekLimit].filter(Boolean).sort()[0];

    const handleChange = async (newValue) => {
        if (newValue === null) {
            await saveItemPropertyOverride(row, null);
            return;
        }
        if (!newValue.isValid()) return;
        const selected = newValue.format('YYYY-MM-DD');
        // Guard against typed input that bypasses the disabled calendar days.
        if (!isSunday(selected)) {
            showInMarketDateError('In-market date must be a Sunday.');
            return;
        }
        if (min && selected < min) return;
        if (max && selected > max) return;
        await saveItemPropertyOverride(row, selected);
    };

    return (
        <TableCell align="center" className={className} sx={{ padding: '0 6px' }}>
            <DatePicker
                value={value ? dayjs(value) : null}
                disabled={row.salesGeographyId == null}
                onChange={handleChange}
                minDate={min ? dayjs(min) : undefined}
                maxDate={max ? dayjs(max) : undefined}
                shouldDisableDate={(date) => date.day() !== 0}
                slotProps={{
                    textField: { size: 'small', fullWidth: true, sx: { backgroundColor: 'white', borderRadius: 1 } },
                    field: { clearable: true }
                }}
            />
        </TableCell>
    );
};

SalesGeographyInMarketDatePicker.propTypes = {
    row: PropTypes.object,
    className: PropTypes.string
};
